import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'

import { routes } from '../../constants/routes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const AdminNav = () => {
    const [ isOpen, setIsOpen ] = useState(false)

    const renderMenuOverlay = () => {
        return (
            <div className={`menu-overlay ${isOpen ? 'active' : ''}`}>
                <div className="closer" onClick={() => setIsOpen(false)}>
                    <FontAwesomeIcon icon="times" />
                </div>
                <div className="menu">
                    <div className="links">
                        {/* <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.adminIndex.path} end>Admin Dashboard</NavLink> */}
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.adminInstallationIndex.path}>Installations</NavLink>
                        {/* <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.adminTrucksIndex.path}>Trucks</NavLink> */}
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.adminTemplateIndex.path}>Templates</NavLink>
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.adminTemplateGroupIndex.path}>Question Groups</NavLink>
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.adminQuestionIndex.path}>Questions</NavLink>
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.adminAccountsIndex.path}>Accounts</NavLink>
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.appIndex.path}>App</NavLink>
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.authLogout.path}>Logout</NavLink>
                    </div>
                    <div className="logo-wrapper">
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.adminInstallationIndex.path}>
                            <img src="/imgs/optimus-gear-only-white.svg" alt="Optimus Technologies" height="50" />
                        </NavLink>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className={`nav ${isOpen ? 'open' : ''}`}>
                <div className="container nav-wrapper">
                    <div className="menu-wrapper">
                        <span className="hamburger" onClick={() => setIsOpen(!isOpen)}>
                            <FontAwesomeIcon icon="bars" />
                        </span>
                    </div>
                </div>
            </div>
            { renderMenuOverlay() }
        </>
    )
}

export default AdminNav
